import { createPinia } from 'pinia';

// Create Pinia store instance
export const pinia = createPinia();

// Store plugins can be added here
// pinia.use(somePlugin);

export default pinia;
